import React, { useState } from "react";
import RivileCategoryEach from "./RivileCategoryEach";
import { CheckBoxInput } from "../../common/Buttons";
import { FaPlus, FaMinus } from "react-icons/fa";
import { updateShopCategories } from "../../../redux/Actions/shopCategoriesAction";

function TableColumnRivileService({ item, index, setCategory, setLoading }) {
  const [CurrentOpen, setCurrentOpen] = useState([]);

  const handleToggle = (value) => {
    const currentIndex = CurrentOpen.indexOf(value);
    const newChecked = [...CurrentOpen];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setCurrentOpen(newChecked);
  };
  const handleCheckboxChangeV2 = (item) => {
    const value = !item.pvm25;

    const ids = [...new Set(checkboxMassFunction(item, []))];
    let body = {
      pvm25: value,
      ids,
    };
    if (value) {
      const currentArray = [...new Set([...CurrentOpen, ...ids])];
      setCurrentOpen(currentArray);
    }
    setLoading(true);
    updateShopCategories(body).then((res) => {
      console.log(res);
      setCategory(res.data);
    }).finally(() => {
      setLoading(false);
    });
  };

  const checkboxMassFunction = (childrenArray, array = []) => {
    let new_array = array;
    if (childrenArray.id) {
      new_array.push(childrenArray.id);
    }
    childrenArray?.children?.forEach((arrayItem) => {
      new_array.push(arrayItem.id);
      if (arrayItem?.children?.length > 0) {
        return checkboxMassFunction(arrayItem, new_array);
      }
    });
    return new_array;
  };

  return (
    <React.Fragment key={index}>
      <tr className="align-middle tableColumn">
        <td className="align-middle">{item.id}</td>
        <td className="align-middle" style={{ cursor: "pointer" }}>
          <div onClick={() => handleToggle(item.id)}>
            {CurrentOpen.includes(item.id) ? (
              <FaMinus title="Close" className="mr-2 text-danger" />
            ) : (
              <FaPlus title="Open" className="mr-2 text-success" />
            )}
            {item.title}{" "}
            {item.children && (
              <span className="font-weight-bold">({item.children.length})</span>
            )}
          </div>
        </td>
        <td>
          <CheckBoxInput
            type="checkbox"
            color="#f7951e"
            checked={item.pvm25}
            onChange={() => handleCheckboxChangeV2(item)}
          />
        </td>
      </tr>
      {CurrentOpen.includes(item.id) &&
        typeof item.children !== "undefined" &&
        item.children.length > 0 &&
        item.children.map((item, index) => {
          return (
            <RivileCategoryEach
              key={index}
              item={item}
              level={10}
              CurrentOpen={CurrentOpen}
              handleToggle={handleToggle}
              handleCheckboxChange={handleCheckboxChangeV2}
            />
          );
        })}
    </React.Fragment>
  );
}

export default TableColumnRivileService;
